import type { FreightChoice } from '../types/nurseryAccounts';

/**
 * The freight question asked at invoicing when neither the customer nor its
 * head office says what freight it pays (FreightChoiceFields). What is typed,
 * and what the server is sent.
 */

export type FreightOption = 'flat' | 'pct' | 'both' | 'zone' | 'none';

export const FREIGHT_OPTIONS: FreightOption[] = ['flat', 'pct', 'both', 'zone', 'none'];

export interface FreightChoiceDraft {
  option: FreightOption;
  flat: string;
  pct: string;
  label: string;
  /** Keep it as the customer's freight, so it is not asked again. */
  save: boolean;
}

export const EMPTY_FREIGHT_CHOICE: FreightChoiceDraft = { option: 'flat', flat: '', pct: '', label: '', save: true };

const num = (s: string) => (s.trim() === '' ? NaN : Number(s));

/** What the server is sent, or null while the figures are not usable. */
export function freightChoiceFrom(d: FreightChoiceDraft): FreightChoice | null {
  if (d.option === 'zone' || d.option === 'none') {
    return { mode: d.option, flat: 0, pct: 0, label: null, save: d.save };
  }
  const flat = d.option === 'pct' ? 0 : num(d.flat);
  const pct = d.option === 'flat' ? 0 : num(d.pct);
  if (!Number.isFinite(flat) || flat < 0 || !Number.isFinite(pct) || pct < 0 || pct > 100) return null;
  return { mode: 'custom', flat, pct, label: d.label.trim() || null, save: d.save };
}
